export default {
      id: "ic_infos-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ic_infos-usage",
      toString: function () {
        return this.url;
      }
    }